import { render, staticRenderFns } from "./InfosetsMemberActionsMenu.vue?vue&type=template&id=3356de4e&"
import script from "./InfosetsMemberActionsMenu.vue?vue&type=script&lang=ts&"
export * from "./InfosetsMemberActionsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./InfosetsMemberActionsMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports